import { Slide } from "@mui/material";
import React from "react";
import EBooks from "../EBooks";
import PricingTable from "../PricingTable";


const ServicesOffered = () => {
  return <div>
 <PricingTable />


  </div>;
};

export default ServicesOffered;
